import { create } from "zustand";

import type { PageInfo } from "@/types/pages.types";

interface PagesState {
  pages: PageInfo[];
  isLoading: boolean;
  error: string | null;

  setPages: (pages: PageInfo[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const usePagesStore = create<PagesState>((set) => ({
  pages: [],
  isLoading: false,
  error: null,

  setPages: (pages) => set({ pages, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  reset: () => set({ pages: [], isLoading: false, error: null }),
}));
